export default [
  {
    key: 'id',
    type: 'id',
  },
  {
    key: 'image_url',
    label: 'Ikon',
    type: 'image',
  },
  {
    key: 'name',
    label: 'Nama',
  },
  {
    key: 'code',
    label: 'Kode',
    visibility: ['view'],
  },
  {
    key: 'gateway',
    label: 'Penyedia Layanan Pembayaran',
    type: 'badge',
    map: {
      midtrans: 'primary',
      xendit: 'danger',
    },
    filter: {
      key: 'category',
      type: 'select',
      label: 'Kategori',
      options: [
        { value: 'midtrans', text: 'Midtrans' },
        { value: 'xendit', text: 'Xendit' },
      ],
    },
  },
  {
    key: 'category',
    label: 'Kategori',
    type: 'badge',
    map: {
      VA: 'primary',
      E_WALLET: 'warning',
      CC: 'success',
      CSTORE: 'info',
    },
    filter: {
      key: 'category',
      type: 'select',
      label: 'Kategori',
      options: [
        { value: 'E_WALLET', text: 'e-Wallet' },
        { value: 'VA', text: 'Virtual Account' },
        { value: 'CC', text: 'Credit Card' },
        { value: 'CSTORE', text: 'Offline Store' },
      ],
    },
  },
  {
    key: 'payment_method_fee',
    label: 'Biaya Layanan',
    type: 'rupiah',
    prefix: 'Rp ',
  },
  {
    key: 'is_active',
    label: 'Status',
    filter: {
      key: 'is_active',
      type: 'select',
      label: 'Status',
      options: [
        { value: true, text: 'Aktif' },
        { value: false, text: 'Tidak aktif' },
      ],
    },
  },
  {
    key: 'created_at',
    label: 'Dibuat',
    type: 'datetime',
    filter: {
      type: 'datetime',
      startKey: 'created_at_gte',
      endKey: 'created_at_lt',
    },
  },
]
